import { render, staticRenderFns } from "./gateway-config.vue?vue&type=template&id=22727077&"
import script from "./gateway-config.vue?vue&type=script&lang=js&"
export * from "./gateway-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports